import { envConfig } from "../config/env";

/**
 * TM / Integrate Manager module name for `GET .../eSignSetting?moduleName=`.
 * Override with `VITE_ESIGN_MODULE_NAME` when the registered name differs.
 */
export const ESIGN_MODULE_NAME = envConfig.eSignModuleName;

/**
 * Freyr `ESignValidation` language code. Wiki: use `"en"` when the host has no i18n.
 * Do not pass `navigator.language` (`zh-CN` / `en-US`) — Freyr resource bundles are `en` / `zhCN` / `jp`.
 */
export const ESIGN_LANGUAGE = "en";

/**
 * Appended to Freyr's dialog title (`E-signature` + space + this).
 * Login Authentication: `${t('esignature.loginPassword')} ${progressStateButtonsignText}`
 */
export const ESIGN_DIALOG_TITLE_SUFFIX = "(Sign to Submit)";
